import React from 'react'
import {Tooltip} from "antd"

const TableHead = (props) => {
    return (
        <thead className="RequestUpdateTableHead TableHead">
        <tr className="RuleHeadTable">
            <th className="Barcode_item">Barcode item</th>
            <th className="ShippingCarrier">SKU</th>
            <th className="Platform">Ngày tạo request</th>
            <th className="Country">Ngày update request</th>
            <th className="State">Trạng thái request</th>
            <th className="Store">Forced update</th>
            <th className="SKU">Source</th>
            <th className="Weight">
                Trạng thái đơn <Tooltip placement="top" overlayClassName="customTooltip"
                                        title="Trạng thái đơn lúc gửi request update.">
                <i className="icon-info22"/>
            </Tooltip>
            </th>
            <th className="Weight">
                Trạng thái FAC <Tooltip placement="top" overlayClassName="customTooltip"
                                        title="Trạng thái hiện tại của đơn trên FAC.">
                <i className="icon-info22"/>
            </Tooltip>
            </th>
            <th className="Weight">
                Trạng thái 3D <Tooltip placement="top" overlayClassName="customTooltip"
                                       title="Trạng thái hiện tại trên Tool3D.">
                <i className="icon-info22"/>
            </Tooltip>
            </th>
        </tr>
        </thead>
    )
}

export default TableHead
